import React from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";
import DetailsTable from "../../Table/DetailsTable";

const COLUMNS = [
  {
    key: "memberId",
    name: "Member ID",
    fieldName: "memberId",
    minWidth: 80,
    maxWidth: 100,
    isResizable: true,
  },
  {
    key: "email",
    name: "Email",
    fieldName: "email",
    minWidth: 200,
    maxWidth: 300,
    isResizable: true,
  },
  {
    key: "firstName",
    name: "First Name",
    fieldName: "firstName",
    minWidth: 100,
    maxWidth: 150,
    isResizable: true,
  },
  {
    key: "lastName",
    name: "Last Name",
    fieldName: "lastName",
    minWidth: 100,
    maxWidth: 150,
    isResizable: true,
  },
];

const UnsubscribeTable = ({ 
  users, 
  infoMessage, 
  emptyMessage = "No unsubscribes found.",
  subuserName 
}) => {
  return (
    <div style={{ marginTop: "20px" }}>
      <MessageBar messageBarType={MessageBarType.info} style={{ marginBottom: "15px" }}>
        {infoMessage}
        {subuserName && (
          <div style={{ marginTop: "5px" }}>
            <strong>Subusers checked:</strong> {subuserName}
          </div>
        )}
      </MessageBar>

      {users?.length > 0 ? (
        <DetailsTable
          items={users}
          columns={COLUMNS}
          enableShimmer={false}
          selectionMode={0}
          compact={false}
        />
      ) : (
        <MessageBar messageBarType={MessageBarType.success}>
          {emptyMessage}
        </MessageBar>
      )}
    </div>
  );
};

export default UnsubscribeTable;
export { COLUMNS };
